import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {DcPageContentSearchResponse} from "../model/dto/entity/dc-page-content-search-response.dto";
import {MvsCrudService} from "../../../core/shared/service/crud/mvs-crud.service";
import {DcPageContentDisplayModeResponseDto} from "../model/dto/entity/dc-meta-reference.dto";

@Injectable({
  providedIn: 'root'
})
export class DcPageContentService extends MvsCrudService{

  constructor(protected http: HttpClient) {
    super(http, MvsCrudService.baseUrl + '/dc/pageContents')
  }

  searchContent(query: string): Observable<DcPageContentSearchResponse> {
    const params = new HttpParams().set('query', query);
    return this.http.get<DcPageContentSearchResponse>(`${this.apiUrl}/search`, { params });
  }

  searchContentByPage(pageId: number, query: string): Observable<DcPageContentSearchResponse> {
    const params = new HttpParams().set('query', query);
    return this.http.get<DcPageContentSearchResponse>(`${this.apiUrl}/search/${pageId}`, { params });
  }

  getContentById(contentId: number): Observable<DcPageContentDisplayModeResponseDto> {
    const endPoint = this.apiUrl + '/getDisplayMode/' + contentId;
    return this.http.get<DcPageContentDisplayModeResponseDto>(endPoint);
  }

  getContentsByPageId(pageId: number): Observable<DcPageContentDisplayModeResponseDto[]> {
    const endPoint = this.apiUrl + '/getDisplayContentFromPage/' + pageId;
    return this.http.get<DcPageContentDisplayModeResponseDto[]>(endPoint);
  }

  updatePageContent(contentId: number, content?: string, orderPriority?: number, sectionId?: number, pageId?: number): Observable<DcPageContentDisplayModeResponseDto> {

    const params: any = {};

    if (content !== undefined && content !== null) {
      params.content = content;
    }

    if (orderPriority !== undefined && orderPriority !== null) {
      params.orderPriority = orderPriority;
    }

    if (sectionId !== undefined && sectionId !== null) {
      params.sectionId = sectionId;
    }

    if (pageId !== undefined && pageId !== null) {
      params.pageId = pageId;
    }

    const endPoint = `${this.apiUrl}/update/${contentId}`;
    return this.http.post<DcPageContentDisplayModeResponseDto>(
        endPoint,
        null,
        { params }
    );
  }

}
